import "../index.css";
import { PencilIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { UserRoleTag } from "@/components/columns/UserRoleTag";
import type { IUser } from "@/types/users";
import { Card, Heading, IconButton, LabelValue, Row, Tooltip } from "@/ui-kit";
import { PhoneUtils } from "@/utils/phone";

type IProps = {
  user: Pick<
    IUser,
    "fullName" | "role" | "phone" | "email" | "profilePicturePath"
  >;
  onEdit?: () => void;
};

export const UserOverviewCard = ({ user, onEdit }: IProps) => {
  const { t } = useTranslation();
  const labelWidth = "60px";

  return (
    <Card className="profile-card">
      <Card.Body>
        <div className="profile-card__layout">
          <img
            className="profile-card__image"
            src={user.profilePicturePath}
            alt="User avatar"
          />
          <div className="profile-card__details">
            <Row gap="sm">
              <Heading level={3} tone="default">
                {user.fullName}
              </Heading>
              <UserRoleTag value={user.role} tagProps={{ size: "md" }} />

              {onEdit && (
                <div className="profile-card__actions">
                  <Tooltip content={t("action.edit")} placement="bottom-end">
                    <IconButton
                      size="sm"
                      variant="ghost"
                      color="neutral"
                      content={<PencilIcon />}
                      onClick={onEdit}
                      aria-label={t("action.edit")}
                    />
                  </Tooltip>
                </div>
              )}
            </Row>

            <div className="profile-card__sections">
              <div className="profile-card__section">
                <LabelValue
                  label={t("label.phone")}
                  value={PhoneUtils.format(user.phone)}
                  labelWidth={labelWidth}
                  canCopy
                />
                <LabelValue
                  label={t("label.email")}
                  value={user.email}
                  labelWidth={labelWidth}
                  canCopy
                />
              </div>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};
